import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRunNormalSmall = React.forwardRef(
  ({ color, size, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      fill={color}
      width={size}
      height={size}
      {...props}
    >
      <path d="M23 17.45c-1.95-1.75-4.12-3.78-4.39-4.12S17.43 10.39 16.54 8c-.44-2.77-.9-3.09-1.14-3.26a1.78 1.78 0 00-1.05-.34 3.63 3.63 0 00-1.87.74 4.1 4.1 0 01-2.13.86 2.65 2.65 0 01-1-.19c-.55-.21-.57-.43-.61-1a1.9 1.9 0 00-.67-1.56A1.24 1.24 0 007.38 3C5.82 3 3.55 6.6 2.73 8l-1.31.93a1 1 0 00-.42.91c.28 2.49 2 4.18 5.77 5.63a7.14 7.14 0 012.85 1.79 16.05 16.05 0 003.09 2.34A9.92 9.92 0 0017.8 21c2.69 0 5.57-1.13 5.57-2.81a1 1 0 00-.37-.74zM17.8 20a8.9 8.9 0 01-4.59-1.25c-3.45-2.07-2.87-3-6.09-4.21C3.53 13.15 2.22 11.7 2 9.73l1.48-1.05C4.79 6.42 6.65 4 7.38 4a.24.24 0 01.15 0c.58.42-.29 2 1.5 2.69a3.65 3.65 0 001.32.31c1.86 0 3-1.57 4-1.57a.79.79 0 01.47.15c.37.26.75 2.71.75 2.71l.27.71H14.5a.5.5 0 000 1h1.72l.39 1h-1.37a.5.5 0 000 1H17l.41 1H16a.5.5 0 000 1h1.94c.66.76 4.46 4.19 4.46 4.19-.02.76-2.04 1.81-4.6 1.81z" />
    </svg>
  )
);
SvgSportsRunNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24
};
SvgSportsRunNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number
};
export default SvgSportsRunNormalSmall;
